/* amphr-card-swatches.js — hovering a colour dot shows that colour's photo.
 *
 * Every listener is delegated from document: cards arrive from the collection
 * grid, from search results and from sections fetched over AJAX, so binding per
 * card would miss whatever loads later.
 *
 * A dot without data-swatch-image belongs to a colour whose variants have no
 * image assigned in the admin. It stays inert — showing the previous colour's
 * photo under a different colour's name is worse than not reacting at all.
 *
 * Clicking a dot follows its link to the product in that colour; the preview is
 * only a hover affordance and never intercepts the click.
 */
(function () {
  'use strict';

  function cardOf(dot) {
    return dot.closest('.card');
  }

  function mainImage(card) {
    /* The hover-swap image (.alt) is a sibling; the first one is the primary. */
    return card.querySelector('.ph .card-media img:not(.alt)');
  }

  /* Swapping src on hover means waiting for a download that has not started
     yet — which is the pause between pointing at a dot and seeing the colour.
     Warm the whole row as soon as the pointer touches the card, which is always
     before it reaches a dot inside that card. */
  function preload(card) {
    if (card.dataset.swPreloaded) return;
    card.dataset.swPreloaded = '1';
    card.querySelectorAll('.sw-dot[data-swatch-image]').forEach(function (dot) {
      var img = new Image();
      img.src = dot.getAttribute('data-swatch-image');
    });
  }

  function show(dot) {
    var src = dot.getAttribute('data-swatch-image');
    if (!src) return;
    var card = cardOf(dot);
    var img = card && mainImage(card);
    if (!img) return;

    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.currentSrc || img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }
    /* srcset wins over src, so it has to go before the swap takes effect. */
    img.srcset = '';
    img.src = src;

    /* The card's own hover already fades in the second shot; leaving it visible
       would cover the colour the customer just asked to see. */
    card.classList.add('sw-preview');
    card.querySelectorAll('.sw-dot').forEach(function (el) {
      el.classList.toggle('on', el === dot);
    });
  }

  function restore(card) {
    if (!card) return;
    var img = mainImage(card);
    if (img && img.dataset.originalSrc) {
      img.srcset = img.dataset.originalSrcset || '';
      img.src = img.dataset.originalSrc;
    }
    card.classList.remove('sw-preview');
    card.querySelectorAll('.sw-dot').forEach(function (el) {
      el.classList.remove('on');
    });
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.card');
    if (card) preload(card);
    var dot = e.target.closest('.sw-dot');
    if (dot) show(dot);
  });

  document.addEventListener('mouseout', function (e) {
    var dot = e.target.closest('.sw-dot');
    if (!dot) return;
    /* Moving between two dots of the same card must not flash the original. */
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.sw') === dot.closest('.sw')) return;
    restore(cardOf(dot));
  });

  /* Keyboard: the dots are links, so focus is the equivalent of hover. */
  document.addEventListener('focusin', function (e) {
    var dot = e.target.closest && e.target.closest('.sw-dot');
    if (!dot) return;
    preload(cardOf(dot));
    show(dot);
  });

  document.addEventListener('focusout', function (e) {
    var dot = e.target.closest && e.target.closest('.sw-dot');
    if (dot && !dot.closest('.sw').contains(e.relatedTarget)) restore(cardOf(dot));
  });
})();
